import { Card, CardContent } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  BarFilters,
  CreditosOrganizacion,
  CreditosSuborganizacion,
  CreditosSuscripcion,
  CreditosUsario,
} from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import { FC } from "react";
import { StackedBarChartTooltip } from "./StackedBarChartTooltip";
import { useNavigate } from "react-router-dom";
import HeaderFilters from "./HeaderFilters";

interface Props {
  credits:
    | CreditosOrganizacion[]
    | CreditosSuborganizacion[]
    | CreditosUsario[]
    | CreditosSuscripcion[];
  label: string;
  id?: string;
  totalCreditsFilters: BarFilters;
  handleToggleCredit: (value: string) => void;
}

const CustomStackedBarChart: FC<Props> = ({
  credits,
  label,
  id,
  totalCreditsFilters,
  handleToggleCredit,
}) => {
  const navigate = useNavigate();

  const handleClick = (event: any) => {
    if (!id) return; // En  caso de que no se pase id, no servirá el onClick

    if (!event?.activePayload?.[0]?.payload) return;

    const data = event.activePayload[0].payload;

    navigate(data[id]);
  };

  /* Dejamos solo los tipos activos */
  const activeTypes = totalCreditsFilters.credits.filter(
    (type) => type.isActive
  );

  return (
    <Card sx={{ width: 1 }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#336B87",
          gap: 2,
        }}
      >
        {/* Título y filtros */}
        <HeaderFilters
          totalCreditsFilters={totalCreditsFilters}
          handleToggleCredit={handleToggleCredit}
        />

        {/* Gráfico de barras */}
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={credits}
            margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
            maxBarSize={100}
            onClick={handleClick}
            style={{ cursor: id ? "pointer" : "auto" }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={label}
              angle={-15}
              textAnchor="end"
              interval={0}
              height={80}
            />
            <YAxis />
            <Tooltip content={<StackedBarChartTooltip />} />

            <Legend
              formatter={(value) => {
                const map = {
                  creditos_gastados: "Gastados",
                  creditos_disponibles: "Disponibles",
                  creditos_desperdiciados: "Desperdiciados",
                };
                return map[value as keyof typeof map] || value;
              }}
            />

            {/* Mostramos las opciones disponibles */}
            {activeTypes.map((type) => {
              return (
                <Bar
                  key={type.value}
                  dataKey={type.value}
                  stackId="a"
                  fill={type.color}
                />
              );
            })}
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default CustomStackedBarChart;
